module.exports = __webpack_public_path__ + "media/img/illustrations/meditate-ba37fc1330ef5c2080aad52f2cab7d4c.svg";